
export class TransitionFormInstances {
    public workflowTransitionId: number;

    public formInstanceIds: number[];
}
